module.exports = __webpack_public_path__ + "static/img/NE.7ab0cd02.svg";